import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();  // Get current pathname

  useEffect(() => {
    // Add a timeout to delay the scroll
    const timeoutId = setTimeout(() => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',  // Smooth scrolling
      });
    }, 100);  // Delay of 100ms

    // Cleanup function to clear the timeout if component unmounts or pathname changes
    return () => clearTimeout(timeoutId);
  }, [pathname]);  // Trigger on every pathname change

  return null;
};

export default ScrollToTop;
